import React, { useState, useEffect } from 'react'
import { useGameStore } from '../store/gameStore'
import { cardAPI, battleAPI } from '../services/api'
import './CardLibrary.css'

function CardLibrary() {
  const { userCards, setUserCards, user, setUser } = useGameStore()
  const [drawsLeft, setDrawsLeft] = useState(0)
  const [loading, setLoading] = useState(false)
  const [lastDrawn, setLastDrawn] = useState<any>(null)
  const [selectedAttribute, setSelectedAttribute] = useState<string>('all')

  useEffect(() => {
    fetchDailyDraws()
  }, [])

  const fetchDailyDraws = async () => {
    try {
      const response = await battleAPI.getDailyDraws()
      setDrawsLeft(response.data.remainingDraws)
    } catch (error) {
      console.error('Failed to fetch daily draws:', error)
    }
  }

  const handleDrawCard = async () => {
    if (drawsLeft <= 0) {
      alert('No free draws remaining today! Come back tomorrow.')
      return
    }

    setLoading(true)
    try {
      const response = await cardAPI.drawCard()
      setLastDrawn(response.data.card)
      setDrawsLeft(drawsLeft - 1)

      // Refresh user cards
      const cardsRes = await cardAPI.getUserCards()
      setUserCards(cardsRes.data)
    } catch (error) {
      alert('Failed to draw card: ' + (error as any).response?.data?.error)
    } finally {
      setLoading(false)
    }
  }

  const filteredCards = selectedAttribute === 'all'
    ? userCards
    : userCards.filter((card) => card.attribute === selectedAttribute)

  const attributes = ['all', 'fire', 'water', 'earth', 'wind', 'light', 'dark']
  const attributeEmojis: Record<string, string> = {
    fire: '🔥',
    water: '💧',
    earth: '🪨',
    wind: '🌪️',
    light: '⭐',
    dark: '🌑'
  }

  return (
    <div className="card-library">
      <div className="library-header">
        <h2>🎴 Card Library</h2>
        <div className="draw-info">
          <span className="draw-counter">Free Draws: {drawsLeft}/3</span>
          <button
            className="btn-draw"
            onClick={handleDrawCard}
            disabled={loading || drawsLeft === 0}
          >
            {loading ? 'Drawing...' : 'Draw Card'}
          </button>
        </div>
      </div>

      {lastDrawn && (
        <div className="draw-result">
          <div className="card-preview">
            <h3>{lastDrawn.name}</h3>
            <div className="card-stats">
              <div className="stat">
                <span className="label">Attribute</span>
                <span className="value">{attributeEmojis[lastDrawn.attribute]} {lastDrawn.attribute.toUpperCase()}</span>
              </div>
              <div className="stat">
                <span className="label">Rarity</span>
                <span className={`value rarity-${lastDrawn.rarity}`}>{lastDrawn.rarity.toUpperCase()}</span>
              </div>
              <div className="stat">
                <span className="label">Damage</span>
                <span className="value">{lastDrawn.base_damage}</span>
              </div>
              <div className="stat">
                <span className="label">HP</span>
                <span className="value">{lastDrawn.base_hp}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="filter-section">
        <h3>Filter by Attribute</h3>
        <div className="attribute-filters">
          {attributes.map((attr) => (
            <button
              key={attr}
              className={`filter-btn ${selectedAttribute === attr ? 'active' : ''}`}
              onClick={() => setSelectedAttribute(attr)}
            >
              {attr === 'all' ? '📋 All' : `${attributeEmojis[attr] || ''} ${attr.charAt(0).toUpperCase() + attr.slice(1)}`}
            </button>
          ))}
        </div>
      </div>

      <div className="cards-grid">
        {filteredCards.map((card) => (
          <div key={`${card.id}-${card.count}`} className="card-item">
            <div className={`card-body rarity-${card.rarity}`}>
              <div className="card-header">
                <h4>{card.name}</h4>
                <span className="attribute">{attributeEmojis[card.attribute]}</span>
              </div>
              <div className="card-content">
                <div className="card-stat">
                  <span className="label">ATK</span>
                  <span className="value">{card.base_damage}</span>
                </div>
                <div className="card-stat">
                  <span className="label">HP</span>
                  <span className="value">{card.base_hp}</span>
                </div>
              </div>
              <div className="card-count">×{card.count || 1}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CardLibrary
